<template>
  <form @submit.prevent="vLaunchInvoiceResearch">
    <div class="invoice-research">
      <div class="form-field">
        <label>{{$_('order_number')}}</label>
        <input @input="vSelectedStore('fncde', $event.target.value)" type="number" />
      </div>
      <div class="form-field">
        <label>{{$_('invoice_credit_number')}}</label>
        <input type="number" @input="vSelectedStore('tnfac', $event.target.value)" />
      </div>
      <div class="form-field">
        <label>{{$_('from_invoice_date')}}</label>
        <DatePicker @datepicker:select="vSelectedStore('fdate_fact', $event)" class="form-element"/>
      </div>
      <div class="form-field display-flex justify-content-end">
        <button class="btn">{{$_('research_button')}}</button>
      </div>
    </div> 
  </form>
</template>

<script>
import DatePicker from '@/common/components/widget/DatePicker'

export default {
  data() {
    return {
    }
  },
  components:{
    DatePicker
  },
  methods: {
    vLaunchInvoiceResearch() {
      this.$store.dispatch('facture/SELECT', {key: 'launch',  value: true});
      this.$store.dispatch('facture/SELECT', {key: 'reset_invoice_list',  value: true});

      if(this.$route.query.order_id !== undefined && this.$route.query.order_id !== '') {
        this.$router.push({name: 'invoice'});
      }
    },
    vSelectedStore(key, value) {
      if(key === 'fdate_fact') {
        var DateTmp = value.split('/');
        DateTmp.reverse();
        value = DateTmp.join('');
      }

      this.$store.dispatch('facture/SELECT', {key, value});
    }
  }
};
</script>

<style scoped>
.invoice-research {
  background-color: #f5f5f5;
  padding: 20px;
  display: flex;
  flex-wrap: wrap
}
form {
  width: 1;
}
.form-field {
  margin: 5px;
}
label {
  padding-left: 20px;
}
.form-element {
  width: 200px;
}
</style>